<!-- Hero Section -->
<section class="hero-section">
    <div class="page-title-area">
        <div class="top-branding">
            <img src="assets/images/macbook-pro/logo.png" alt="MacBook Pro" class="brand-logo" style="margin-top: 20px;">
            <h1 style="margin-top: 20px;
            font-size: 52px;
            background: linear-gradient(115deg, #0090F7 30%, #BA62FC 45%, #F2416B 60%, #F55600 70%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            line-height: 1.1;">Super Charged by M4</h1>
        </div>
        <img src="assets/images/macbook-pro/macbook-pro.jpg" alt="Page Background" class="page-bg" style="width: 100%; height: 100%; object-fit: cover;">
        <div class="container">
            <div class="hero-content">
                <!-- <h1>MacBook Pro</h1>
                <h2>Nothing can stop you.</h2> -->
                <p style="font-size: 20px; font-weight: 500; color: #fff; margin-top: 250px;">With MacBook Pro, nothing can stop you. The M4 family of chips brings astounding speed, graphics, and AI capability along with Apple Intelligence. And with up to 24 hours of battery life, you can go all day.</p>
                <div class="hero-buttons">
                    
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Performance Section -->
<section class="performance-section">
    <div class="container">
        <div class="performance-card">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <div class="performance-content">
                        <h3 style="color: #fff; font-size: 36px; margin-bottom: 40px; text-align: center;">Three powerful chips. Pro all out.</h3>
                        <div class="chip-stats">
                            <div class="chip-stat">
                                <div class="stat-image-container">
                                    <img src="assets/images/macbook-pro/m4.png" alt="M4 chip" class="chip-image">
                                </div>
                                <div class="stat-content">
                                    <p style="text-align: center;">Up to 3.4x</p>
                                    <h4 style="text-align: center;">3.4x faster</h4>
                                    <p style="text-align: center;">than M1</p>
                                </div>
                            </div>
                            <div class="chip-stat">
                                <div class="stat-image-container">
                                    <img src="assets/images/macbook-pro/m4-pro.png" alt="M4 Pro chip" class="chip-image">
                                </div>
                                <div class="stat-content">
                                    <p style="text-align: center;">Up to 3x</p>
                                    <h4 style="text-align: center;">3x faster</h4>
                                    <p style="text-align: center;">than M1 Pro</p>
                                </div>
                            </div>
                            <div class="chip-stat">
                                <div class="stat-image-container">
                                    <img src="assets/images/macbook-pro/m4-max.png" alt="M4 Max chip" class="chip-image">
                                </div>
                                <div class="stat-content">
                                    <p style="text-align: center;">Up to 3.5x</p>
                                    <h4 style="text-align: center;">3.5x faster</h4>
                                    <p style="text-align: center;">than M1 Max</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Battery Life Section -->
<section class="battery-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="feature-card">
                    <div class="card-content">
                        <img src="assets/images/macbook-pro/battery.jpg" alt="MacBook Pro Battery Life" class="feature-image">
                        <h3 style="color: #fff; font-size: 36px; margin-top: 30px;">Up to 24 hours of battery life.</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="feature-card">
                    <div class="card-content">
                        <img src="assets/images/macbook-pro/graphics.png" alt="MacBook Pro Graphics Performance" class="feature-image">
                        <h3 style="color: #fff; font-size: 36px; margin-top: 30px;">Next-level graphics performance. Game on.</h3>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</section>

<!-- Size and Color Section -->
<section class="features-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="feature-card">
                    <div class="card-content">
                        <div class="size-display">
                            <img src="assets/images/macbook-pro/size.png" alt="MacBook Pro Sizes" class="feature-image">
                            <div class="size-labels">
                                <div class="size-label left">
                                    <h4>14"</h4>
                                    <p>display</p>
                                </div>
                                <div class="size-label right">
                                    <h4>16"</h4>
                                    <p>display</p>
                                </div>
                            </div>
                        </div>
                        <p style="color: #86868b; text-align: center; margin-top: 20px; font-size: 18px;">Both sizes available in Space Black and Silver.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="feature-card">
                    <div class="card-content">
                        <div class="integration-display">
                            <img src="assets/images/macbook-pro/mac_iphone.png" alt="Mac and iPhone Integration" class="feature-image" style="width: 50%; height: 50%; object-fit: contain;">
                            <div class="overlay-text">
                                <h3>Mac + iPhone.<br>Better together.</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Display Section -->
<section class="display-section">
    <div class="container">
        <!-- First Card -->
        <div class="display-card">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="display-image">
                        <img src="assets/images/macbook-pro/display.png" alt="MacBook Pro Display" class="feature-image">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="display-content">
                        <h3 style="color: #fff; font-size: 36px; margin-bottom: 30px;">Stunning Liquid Retina XDR display.</h3>
                        <div class="display-stats">
                            <div class="stat">
                                <h4 style="color: #fff; font-size: 48px; margin-bottom: 10px;">1600</h4>
                                <p style="color: #86868b;">nits peak HDR brightness</p>
                            </div>
                            <div class="stat">
                                <h4 style="color: #fff; font-size: 48px; margin-bottom: 10px;">1000</h4>
                                <p style="color: #86868b;">nits sustained HDR brightness</p>
                            </div>
                            <div class="stat">
                                <h4 style="color: #fff; font-size: 48px; margin-bottom: 10px;">1000</h4>
                                <p style="color: #86868b;">nits SDR brightness outdoors</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Second Card -->
        <div class="display-card" style="margin-top: 40px;">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="display-image">
                        <img src="assets/images/macbook-pro/camera.png" alt="MacBook Pro Camera Features" class="feature-image">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="display-content">
                        <h3 style="color: #fff; font-size: 36px; margin-bottom: 30px;">Look and sound your best</h3>
                        <div class="feature-list">
                            <div class="feature-item">
                                <img src="assets/images/macbook-pro/icon_video.png" alt="Camera" class="feature-icon">
                                <p style="color: #fff; margin-left: 15px;">12MP camera with Center Stage and Desk View</p>
                            </div>
                            <div class="feature-item">
                                <img src="assets/images/macbook-pro/icon_waveform.png" alt="Microphone" class="feature-icon">
                                <p style="color: #fff; margin-left: 15px;">Studio-quality three‑mic array</p>
                            </div>
                            <div class="feature-item">
                                <img src="assets/images/macbook-pro/icon_person_spatialaudio.png" alt="Audio" class="feature-icon">
                                <p style="color: #fff; margin-left: 15px;">Six-speaker sound system with Spatial Audio</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Ports Section -->
<section class="ports-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="feature-card">
                    <div class="card-content">
                        <h3 style="color: #fff; font-size: 36px; margin-bottom: 30px;">Pro ports. Fast connections.</h3>
                        <img src="assets/images/macbook-pro/port.png" alt="MacBook Pro Ports" class="feature-image">
                        <p style="color: #fff; font-size: 18px; margin-top: 20px; line-height: 1.5;">
                            MagSafe charging, Three Thunderbolt 4 ports, HDMI port, SDXC card slot
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="feature-card">
                    <div class="card-content">
                        <h3 style="color: #fff; font-size: 36px; margin-bottom: 30px;">Unrivaled security.</h3>
                        <div class="security-features">
                            <div class="security-item">
                                <img src="assets/images/macbook-pro/touch_id.png" alt="Touch ID" class="security-icon">
                                <div class="security-text">
                                    <h4 style="color: #fff; font-size: 24px; margin-bottom: 10px;">Touch ID</h4>
                                    <p style="color: #86868b;">Unlock your Mac and make secure purchases with your fingertip.</p>
                                </div>
                            </div>
                            <div class="security-item">
                                <img src="assets/images/macbook-pro/find_my.png" alt="Find My" class="security-icon">
                                <div class="security-text">
                                    <h4 style="color: #fff; font-size: 24px; margin-bottom: 10px;">Find My</h4>
                                    <p style="color: #86868b;">Locate your devices, even when they're offline.</p>
                                </div>
                            </div>
                            <div class="security-item">
                                <img src="assets/images/macbook-pro/file_vault.png" alt="Privacy" class="security-icon">
                                <div class="security-text">
                                    <h4 style="color: #fff; font-size: 24px; margin-bottom: 10px;">FileVault</h4>
                                    <p style="color: #86868b;">Control what you share and how your information is used.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- AI Section -->
<section class="ai-section">
    <div class="container">
        <div class="ai-card">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="ai-image">
                        <img src="assets/images/macbook-pro/ai.jpg" alt="MacBook Pro Apple Intelligence" style="width: 100%; height: auto;">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="ai-content text-center">
                        <h2 style="font-size: 56px; margin-bottom: 20px;">
                            <span style="background: linear-gradient(115deg, #0090F7 30%, #BA62FC 45%, #F2416B 60%, #F55600 70%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">Built for<br>Apple Intelligence.</span>
                        </h2>
                        <h3 style="color: #fff; font-size: 32px; margin-bottom: 15px;">Personal, private, powerful.</h3>
                        <p style="color: #86868b; font-size: 20px;">Apple Intelligence available now in U.S. English.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
